<template>
  <generic-button
      @click="$emit('click')"
      :variant="variant"
      :title="withText?'send':''"
      :icon="withIcon?'paper-plane':''"
      :size="size"
      :block="block"
      :is-disabled="disabled"
  />
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericButton from './Button'

export default {
  components: {
    GenericButton
  },
  props: {
    withIcon: {
      type: Boolean,
      default: false
    },
    withText: {
      type: Boolean,
      default: true
    },
    withBorder: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md'
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const variant = computed(() => {
      if (props.withBorder) {
        return 'outline-primary'
      } else {
        return 'flat-primary'
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      variant,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>